export default {
  "content": "<path d=\"M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z\" fill=\"#000\" fill-opacity=\".03\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 20a9 9 0 1118.001.001A9 9 0 0111 20zm2 0c0 3.86 3.14 7 7 7s7-3.14 7-7-3.14-7-7-7-7 3.14-7 7zm6-2.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm3.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-5.26 2.11A2.98 2.98 0 0020 22.99c1.21 0 2.3-.73 2.76-1.88l1.86.76A4.987 4.987 0 0120 24.99c-2.03 0-3.84-1.22-4.62-3.12l1.86-.76z\" fill=\"#000\" fill-opacity=\".3\"/>",
  "attrs": {
    "width": "40",
    "height": "40",
    "viewBox": "0 0 40 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};